import { CSS, type Transform } from '@dnd-kit/utilities';
import React from 'react';
import { ChakraV3 } from '..';

interface Props extends Omit<ChakraV3.BoxProps, 'transform'> {
  transform: Transform | null;
  transition: string | undefined;
}

export const Sortable = React.forwardRef((props: Props, ref) => {
  const { transform, transition, children, ...rest } = props;

  return (
    <ChakraV3.Box
      ref={ref}
      transform={CSS.Translate.toString(transform)}
      transition={transition}
      {...rest}
    >
      {children}
    </ChakraV3.Box>
  );
});
